import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import Immutable, { Map } from 'immutable';
import { ImageFromField } from '@uncinc/react-drupal-core';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

import { NodeEvent } from '../../../../types/nodes';
import EventMetaData from '../../../../components/EventMetaData';
import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  SCREEN_WIDE,
} from '../../../../config/constants';
import { Button } from '../../../../components';

interface EventTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeEvent>;
  flipped?: boolean;
}

const EventTeaser: React.FC<EventTeaserProps> = ({ entity, flipped }) => {
  const { t } = useTranslation();
  const event = entity.toJS();
  const title = event.title[0].value;
  const body = event.body[0]?.processed;
  const url = event.paths.nl;

  return (
    <div className={`EventTeaser ${flipped ? 'EventTeaser--flipped' : ''}`}>
      <div className="row">
        <div className={`col-md-5 ${flipped ? 'offset-md-1' : ''}`}>
          <ImageFromField
            className="media__image u-margin--bottom--5"
            field={Immutable.fromJS(event.field_media_item[0])}
            imageStyles={Map({
              [SCREEN_MOBILE]: 'cropped_standard_medium_viewport',
              [SCREEN_TABLET]: 'cropped_standard_medium_viewport',
              [SCREEN_NORMAL]: 'cropped_standard_medium_viewport',
              [SCREEN_WIDE]: 'cropped_standard_large_viewport',
            })}
            lazyload
          />
        </div>
        <div className={`col-md-6 ${flipped ? '' : 'offset-md-1'}`}>
          <h2>{title}</h2>
          <EventMetaData event={entity.toJS()} />
          {body && (
            <WysiwygField
              className="u-margin--top--5"
              property="schema:text"
              html={body}
            />
          )}
          <Button href={url} className="u-margin--top--5">
            {t('more_about_this_event')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EventTeaser;
